import { useMemo } from 'react'
import type { ApiContext } from '@/lib/api'
import { selectApiContext, useSettingsStore } from '@/stores/settingsStore'

/** The API context, memoised on the settings that actually shape a request. */
export function useApiContext(): ApiContext {
  const baseUrl = useSettingsStore((state) => state.baseUrl)
  const route = useSettingsStore((state) => state.route)
  const bearerToken = useSettingsStore((state) => state.bearerToken)
  const requestTimeoutMs = useSettingsStore((state) => state.requestTimeoutMs)

  return useMemo(
    () =>
      selectApiContext({
        baseUrl,
        route,
        bearerToken,
        requestTimeoutMs,
      } as Parameters<typeof selectApiContext>[0]),
    [baseUrl, route, bearerToken, requestTimeoutMs],
  )
}
